import { makeDsn as c, dsnToString as $ } from "./chunk1185.js";
function m(o) {
  const e = o.protocol ? `${o.protocol}:` : "", n = o.port ? `:${o.port}` : "";
  return `${e}//${o.host}${n}${o.path ? `/${o.path}` : ""}/api/`;
}
function f(o, e) {
  const n = c(o);
  if (!n)
    return "";
  const p = `${m(n)}embed/error-page/`;
  let i = `dsn=${$(n)}`;
  for (const t in e)
    if (t !== "dsn" && t !== "onClose")
      if (t === "user") {
        const r = e.user;
        if (!r)
          continue;
        r.name && (i += `&name=${encodeURIComponent(r.name)}`), r.email && (i += `&email=${encodeURIComponent(r.email)}`);
      } else
        i += `&${encodeURIComponent(t)}=${encodeURIComponent(e[t])}`;
  return `${p}?${i}`;
}
export {
  f as getReportDialogEndpoint
};
